import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useGetChallengeById } from '_api';
import { ChallengeRouteMap } from '_constants';
import { StyledDetailDescription, ThumbnailView } from 'components/atoms';
import React, { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { IoMdArrowBack } from 'react-icons/io';
import { getVideoAspectRatio, useNavigateTo } from 'utils';
import { useUser } from 'utils/hooks';

import { DetailViewProps } from './types';

export const ChallengeDetail = ({ id }: DetailViewProps) => {
  const navigate = useNavigateTo();
  const theme = useTheme();
  const { data: challenge, isFetching: isLoading } = useGetChallengeById(id);
  const [isVertical, setIsVertical] = useState(false);
  const { isAdmin } = useUser();

  useEffect(() => {
    if (challenge && challenge.fullVideoUrl) {
      getVideoAspectRatio(challenge.fullVideoUrl, (ratio) => {
        if (ratio < 1) {
          setIsVertical(true);
        } else {
          setIsVertical(false);
        }
      });
    }
  }, [challenge]);

  if (!challenge && !isLoading) {
    return <Typography variant="h6">Challenge Not Found...</Typography>;
  }

  const handleBack = () => {
    history.back();
  };
  const handleOnEdit = () => {
    navigate(ChallengeRouteMap.EDIT, id.toString());
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: '50px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ marginTop: '10px', color: `${theme.palette.primary.main}` }}>
          <IoMdArrowBack />
        </Box>
        <Button onClick={handleBack} sx={{ justifyContent: 'left' }}>
          {' '}
          Back{' '}
        </Button>
      </Box>
      {challenge && !isLoading ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant={'h3'} gutterBottom>
              {challenge.title}
            </Typography>
            {isAdmin ? (
              <Tooltip title={'Edit'} placement="top">
                <span>
                  <IconButton
                    onClick={handleOnEdit}
                    sx={{
                      color: theme.palette.primary.main,
                      paddingLeft: '10px',
                      marginBottom: '20px',
                    }}
                  >
                    <FaEdit />
                  </IconButton>
                </span>
              </Tooltip>
            ) : null}
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: isVertical ? 'row' : 'column',
            }}
          >
            <ThumbnailView
              placeholder={true}
              fullImageUrl={challenge.fullImageUrl}
              fullVideoUrl={challenge.fullVideoUrl}
            />
            <Box
              sx={{
                paddingTop: isVertical ? '' : '20px',
                paddingLeft: isVertical ? '20px' : '',
              }}
            >
              <StyledDetailDescription variant="body1" sx={{ marginBottom: '16px' }}>
                {challenge.description}
              </StyledDetailDescription>
              {challenge.instructionList.map((inst, i) => (
                <StyledDetailDescription key={`${id}-instruction-${i}`}>
                  &bull; {inst}
                </StyledDetailDescription>
              ))}
            </Box>
          </Box>
        </>
      ) : (
        <Box sx={{ margin: 'auto' }}>
          <CircularProgress size={'5rem'} />
        </Box>
      )}
    </Box>
  );
};
